import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appendTo", "disabled", "ellipsis", "enterDelay", "exitDelay", "fixed", "flip", "maxWidth", "moveArrowTo", "onHide", "onShow", "placement", "showTooltip", "textAlign", "zIndex", "maxLines"];

/**
 * A utility function that extracts Ellipsis relevant props and wrapped Component relevant props
 * @returns {{ellipsisProps: *, componentProps: *}}
 */
export var extractEllipsisProps = function extractEllipsisProps(_ref) {
  var appendTo = _ref.appendTo,
      disabled = _ref.disabled,
      ellipsis = _ref.ellipsis,
      enterDelay = _ref.enterDelay,
      exitDelay = _ref.exitDelay,
      fixed = _ref.fixed,
      flip = _ref.flip,
      maxWidth = _ref.maxWidth,
      moveArrowTo = _ref.moveArrowTo,
      onHide = _ref.onHide,
      onShow = _ref.onShow,
      placement = _ref.placement,
      showTooltip = _ref.showTooltip,
      textAlign = _ref.textAlign,
      zIndex = _ref.zIndex,
      maxLines = _ref.maxLines,
      componentProps = _objectWithoutProperties(_ref, _excluded);

  return {
    ellipsisProps: {
      appendTo: appendTo,
      disabled: disabled,
      ellipsis: ellipsis,
      enterDelay: enterDelay,
      exitDelay: exitDelay,
      fixed: fixed,
      flip: flip,
      maxWidth: maxWidth,
      moveArrowTo: moveArrowTo,
      onHide: onHide,
      onShow: onShow,
      placement: placement,
      showTooltip: showTooltip,
      textAlign: textAlign,
      zIndex: zIndex,
      maxLines: maxLines
    },
    componentProps: componentProps
  };
};